export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-900 text-background-50/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-line text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50 whitespace-nowrap">
                窝窝影院
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/50">
              窝窝影院提供高清播放、在线不缓冲的流畅观影体验，超清画质无广告，海量电影电视剧免费在线观看，每日更新不卡顿，让您享受极致观影。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 text-sm mb-4">
              快速导航
            </h4>
            <div className="space-y-2">
              <a href="#hero" className="block text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">首页</a>
              <a href="#ranking" className="block text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">热播排行</a>
              <a href="#index" className="block text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">分类索引</a>
              <a href="#faq" className="block text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 text-sm mb-4">
              内容分类
            </h4>
            <div className="space-y-2">
              <span className="block text-sm text-background-50/50 cursor-pointer hover:text-background-50/80 transition-colors whitespace-nowrap">动作电影</span>
              <span className="block text-sm text-background-50/50 cursor-pointer hover:text-background-50/80 transition-colors whitespace-nowrap">科幻电影</span>
              <span className="block text-sm text-background-50/50 cursor-pointer hover:text-background-50/80 transition-colors whitespace-nowrap">热门电视剧</span>
              <span className="block text-sm text-background-50/50 cursor-pointer hover:text-background-50/80 transition-colors whitespace-nowrap">动画动漫</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 text-sm mb-4">
              合作伙伴
            </h4>
            <div className="space-y-2">
              <span className="block text-sm text-background-50/50 whitespace-nowrap">更多伙伴即将加入</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-background-50/40">
          <span>&copy; 2020 - 2026 窝窝影院. All rights reserved.</span>
          <div className="flex items-center gap-4">
            <span className="cursor-pointer hover:text-background-50/60 transition-colors whitespace-nowrap">服务条款</span>
            <span className="cursor-pointer hover:text-background-50/60 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="cursor-pointer hover:text-background-50/60 transition-colors whitespace-nowrap">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}